import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Auth } from 'src/app/models/auth';
import { CartaoService } from 'src/app/services/cartao.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

import { CartaoCadastro } from 'src/app/models/cartao-cadastro';
import { CartaoPeriodoPadrao } from 'src/app/shared/enums/cartao-periodo-padrao.enum';
import { FiltroColaboradorService } from 'src/app/services/filtro-colaborador.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { GroupService } from 'src/app/services/group/group.service';
import { Group, GroupColaboratorUpdate, GroupCollaboratorDelete, GroupProduct } from 'src/app/models/group';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SelectedTipoChave } from 'src/app/models/selected-chave-pix';
import { SelectedGrupo } from 'src/app/models/selected-grupo';
import { ColaboratorsGroupService } from 'src/app/services/group/colaborators-group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { ProdutoService } from 'src/app/services/produto.service';
import { SuspendProductRequest } from 'src/app/models/request/suspend-product-request';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';
import { CartaoCadastroItem } from 'src/app/models/cartao-cadastro-item';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ColaboradoresId } from 'src/app/models/colaborador-ids';
import { CartaoCadastroLote } from 'src/app/models/cartao-cadastro-lote';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { Card } from 'src/app/models/card';
import { CreateCard } from 'src/app/models/create-card';
import { ProdutoCategoria } from 'src/app/models/produto-categoria';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCards,AddBatchCards } from 'src/app/models/add-cards';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-colaborador-cartao',
    templateUrl: './colaborador-cartao.component.html',
    styleUrls: ['./colaborador-cartao.component.css']
})
export class ColaboradorCartaoComponent implements OnInit, OnDestroy {
    public erroValor = false;

    public collaboratorName: any;
    private collaboratorId: number;
    private colaboradorDocument: number;
    private urlReturn = null;
    private routeSubscription: Subscription;
    private routeSubscriptionReturn: Subscription;
    private currentUser: Auth;
    private currentManager = null;

    public cedenteId = 0;
    public productsCategory: ProdutoCategoria[];
    public tipoBeneficio: CategoriaProduto;

    public guidGrupoDoColaborador: string;

    public deletaColaborador: GroupCollaboratorDelete;

    public groups: Array<Group>;
    public groupSelected = 0;
    public groupsCtrl: FormControl = new FormControl();

    public persistFilter = false;

    public cartoes: CartaoCadastro[] = [];
    public cards: Card[] = [];
    public cardsBatch: Card[] = [];
    public cardFlex: Card = new Card();
    public cartaoFlex: CartaoCadastro;
    public CartaoPeriodoPadrao: CartaoPeriodoPadrao;
    public suspendProductRequest: SuspendProductRequest;
    public assignorContractsId: number[] = [];
    referenceValues = [];

    public dropdownList = [];
    public dropdownSettings: IDropdownSettings = {};
    public selectedItems: any;
    isDeselected: boolean = false;


    public grupoGuid: string;
    public grupoId: number = 0;
    public grupoNome: string;
    public addColaboradorGrupo: GroupColaboratorUpdate;
    public productsByGroup: Array<GroupProduct>;
    public productFlexGroup: GroupProduct;
    public exibirCadastroFlex = false;
    public isLote = false;
    public isFlex: boolean = false;
    private colaboradoresId = [];
    public cartaoCadastroLote: CartaoCadastroLote;

    isEmpty = false
    public messageErro: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private cartaoService: CartaoService,
        private groupService: GroupService,
        private colaboradorGroupService: ColaboratorsGroupService,
        private contratoService: ContratoService,
        private parametrosDataService: ParametrosDataService,
        private productsGroupService: ProductsGroupService,
        private productService: ProdutoService,
        private colaboradorService: ColaboradorService,
        private filterService: FiltroColaboradorService,
        private modalService: NgbModal) {
    }


    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
    }


    ngOnDestroy() {
        if (!this.persistFilter) {
            this.filterService.clear();
        }
    }

    ngOnInit() {

        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.collaboratorId = +params.get('colaboradorId');
        });

        if(this.router.url == '/portal/colaborador/cartao-lote'){
            this.isLote = true;

            this.colaboradorService.colaboradoresArquivoList.subscribe(ids => {
                if(ids == null){
                    this.previous()
                } else {
                    for(var item of ids){
                        this.colaboradoresId.push(item);
                    }
                }
            });

            localStorage.removeItem(LocalStoreKeys.colaboradoesArquivoList)
        }

        if(sessionStorage.getItem('currentCollaborator') != null){
            this.collaboratorName = sessionStorage.getItem('currentCollaborator');
        }

        this.route.queryParams.subscribe(params => {
            this.colaboradorDocument = +params['doc'] || 0;
        });

        this.routeSubscriptionReturn = this.route.queryParamMap.subscribe(params => {
            if (params != null) {
                this.urlReturn = params.get('urlReturn');
            }
        });

        this.dropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'nome',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true,
            closeDropDownOnSelection: true
        };

        this.loadParametros();

        this.currentUser = this.authenticationService.currentUserValue;
        this.cedenteId = parseInt(sessionStorage.getItem('cedenteId'));
        this.currentManager = JSON.parse(sessionStorage.getItem('gestorCedente'));

        this.productsCategory = JSON.parse(localStorage.getItem('productCategory'));
        this.productsCategory = this.productsCategory.filter(el => el.canList && el.id != CategoriaProduto.Tradicional);
        // this.productsCategory.sort((a, b) => (a.categoryListOrder > b.categoryListOrder) ? 1 : -1);
        this.tipoBeneficio = CategoriaProduto.Flex;
        this.buscarGrupos();
        this.getContracts();
    }

    getContracts(){
        this.contratoService.getContracts(this.currentUser.token.assignorGuid, this.tipoBeneficio).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result) {
                        this.isEmpty = false;

                        if (response.result.length <= 0) {
                            this.isEmpty = true;
                            this.messageErro = response.message;
                            return;
                        }

                        this.referenceValues = [];
                        this.assignorContractsId = [];
                        for (const s of response.result) {
                            this.assignorContractsId.push(s.id);
                            this.referenceValues.push({valorPadrao: s.standardValue,cedenteContratoId: s.id});
                        }
                        this.cartaoService.getValidCardBatch(this.collaboratorId, this.currentUser.token.assignorGuid, this.assignorContractsId).subscribe(
                            responseB => {
                                if(response.status == ApiError.Sucesso){
                                    this.cards = responseB.result.sort((a, b) => a.productDescription.localeCompare(b.productDescription));
                                    this.cards.forEach(element => {
                                        if(element.referenceValue == 0 && this.grupoId == 0 && this.tipoBeneficio == CategoriaProduto.Tradicional){
                                            element.referenceValue = this.referenceValues.find(x=>x.cedenteContratoId == element.assignorContractId).valorPadrao;
                                        }
                                        if(this.isLote && this.cardsBatch.find(x => x.assignorContractId == element.assignorContractId)){
                                            element.active = true;
                                        }
                                    });
                                    if(this.tipoBeneficio == CategoriaProduto.Flex){
                                        this.cardFlex = this.cards[0];
                                        if(this.isLote)
                                            this.selectBatch(this.cardFlex, false);
                                    }
                                }
                            }
                        );
                    }
                } else {
                    //this.alertService.error(response.message);
                }
              }, error => {
                this.alertService.error('Ocorreu um erro ao carregar os incentivos');
            }
        );
    }


    loadParametros() {
        const parametros = this.parametrosDataService.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.temContaFlexivel]) {
                this.exibirCadastroFlex = parametros[ParametrosKey.temContaFlexivel];
            }
        }
    }

    buscarGrupos() {
        this.groupService.getGroupsByCedente(this.currentUser.token.assignorGuid).subscribe(response => {

            if (response.status === 1) {
                this.groups = [];
                response.result.forEach(obj => {
                    this.groups.push(obj);
                });

                this.colaboradorGroupService.getGrupoColaborador(this.currentUser.token.assignorGuid, this.collaboratorId).subscribe(responseGrupoCol => {
                    if (responseGrupoCol.status === 1) {
                        if (responseGrupoCol.result !== '00000000-0000-0000-0000-000000000000') {

                            this.groupService.getGroupById(this.currentUser.token.assignorGuid, responseGrupoCol.result).subscribe(responseDadosGrupo => {
                                if (responseDadosGrupo.status === 1) {

                                    this.grupoId = parseInt(responseDadosGrupo.result.id);
                                    this.grupoNome = responseDadosGrupo.result.name;
                                    this.grupoGuid = responseDadosGrupo.result.guidID;
                                    this.guidGrupoDoColaborador = responseDadosGrupo.result.guidID;
                                    this.addColaboradorGrupo = new GroupColaboratorUpdate();
                                    this.addColaboradorGrupo.collaboratorIDs = [];
                                    this.addColaboradorGrupo.collaboratorIDs[0] = this.collaboratorId;
                                    this.addColaboradorGrupo.groupGuid = this.grupoGuid;

                                    this.callProductsOfGroup(this.grupoGuid);
                                    this.groupsCtrl.setValue(this.grupoId);
                                    this.tipobeneficio(this.tipoBeneficio,true)
                                }
                            });
                        }
                    }

                });
            }
        });

    }
    onItemSelect(item: any) {

        if(item == null){
            this.isDeselected = true;
            this.grupoGuid = null;
            this.productsByGroup = [];
            this.productFlexGroup = null;
        }
        else {
            this.isDeselected = false;
            this.grupoId = item;
            this.groups.forEach(obj => {
                if (obj.id === item) {
                    this.grupoGuid = obj.guidID;
                    this.grupoNome = obj.name;
                }
            });
            this.addColaboradorGrupo = new GroupColaboratorUpdate();
            this.addColaboradorGrupo.collaboratorIDs = [];
            this.addColaboradorGrupo.collaboratorIDs[0] = this.collaboratorId;
            this.addColaboradorGrupo.groupGuid = this.grupoGuid;

            this.callProductsOfGroup(this.grupoGuid);
        }
    }

    onItemDeselect(item: any){
        this.isDeselected = true;
    }

    criarGrupo(value: any) {

        this.router.navigate(['portal/grupos/create']);


    }
    aderirBeneficios() {
        this.router.navigate(['portal/novobeneficio/contratar']);
    }



    onSubmit(content, remove = false) {
        this.erroValor = false;

        if(this.grupoId > 0 && this.tipoBeneficio == CategoriaProduto.Tradicional && !remove){
            this.modalService.open(content, { centered: true, size: 'lg' });
        }
        else{
            this.finish(this.isLote ? this.cardsBatch : this.cards);
        }
    }

    finish(cards: Card[]){

        let addCards = new AddCards();
        addCards.assignorGuid = this.currentUser.token.assignorGuid;
        addCards.managerGuid = this.currentManager.gestorGuid;
        addCards.assignorContractsId = this.assignorContractsId;
        addCards.collaboratorId = this.collaboratorId;
        addCards.groupGuid = this.isDeselected ? null : this.grupoGuid;
        addCards.productCategoryWallet = this.tipoBeneficio;

        cards.forEach(element => {
            if(element.referenceValue == 0 && this.grupoId > 0 && this.tipoBeneficio == CategoriaProduto.Tradicional){
                element.referenceValue = this.referenceValues.find(x=>x.cedenteContratoId == element.assignorContractId).valorPadrao;
            }
        });

        let createCards: CreateCard[] = [];
        if(this.tipoBeneficio == CategoriaProduto.Flex && !this.isLote){
            if(this.groupsCtrl.value === undefined)
                return this.alertService.error("Para adicionar um cartão flex selecione um grupo!");

            this.isFlex = true;
            const createCard = new CreateCard();
            createCard.assignorContractId = this.cardFlex.assignorContractId;
            createCard.assignorContractsId = this.assignorContractsId;
            createCard.cardId = this.cardFlex.cardId;
            createCard.referenceValue = this.cardFlex.referenceValue;
            createCard.regularityId = parseInt(this.cardFlex.regularityId.toString());
            createCard.productGuid = this.cardFlex.productGuid;
            createCard.productCategory = this.cardFlex.productCategory;
            createCard.active = this.cardFlex.active;
            createCards.push(createCard);

        } else{
            cards.forEach(card => {
                const createCard = new CreateCard();
                createCard.cardId = card.cardId;
                createCard.referenceValue = (card.referenceValue == null || card.referenceValue == undefined) ? 0 : card.referenceValue;
                createCard.regularityId = parseInt(card.regularityId.toString());
                createCard.productGuid = card.productGuid;
                createCard.productCategory = card.productCategory;
                createCard.assignorContractId = card.assignorContractId;
                createCard.active = card.active;
                createCard.suspend = card.suspended == null ? false : card.suspended;
                createCards.push(createCard);
            });
        }

        addCards.createCards = createCards;

        if(!this.isLote){
            this.cartaoService.newAdd(addCards,this.isFlex).subscribe(
                response => {
                    if(response.status == ApiError.Sucesso){
                        this.alertService.success("Cartões atualizados!");
                        this.isFlex = false;
                        this.getContracts();
                        this.buscarGrupos();
                    }
                    else{
                        this.alertService.error(response.message);
                        this.isFlex = false;
                    }
                }, error => {console.log(error)}
            )
        } else {
            if(this.tipoBeneficio == CategoriaProduto.Flex){
                addCards.createCards = addCards.createCards.filter(x => x.productCategory != CategoriaProduto.Tradicional);
                this.isFlex = true;
            } else {
                addCards.createCards = addCards.createCards.filter(x => x.productCategory != CategoriaProduto.Flex);
            }

            let addBatchCards = new AddBatchCards();
            addBatchCards.AddCards = addCards;
            addBatchCards.collaboratorsId = this.colaboradoresId;

            this.cartaoService.newAddBatch(addBatchCards,this.isFlex).subscribe(
                response => {
                    if(response.status == ApiError.Sucesso){
                        this.alertService.success("Cartões cadastrados!");
                        this.isFlex = false;
                        this.getContracts();
                        this.buscarGrupos();
                    }
                    else{
                        this.alertService.error(response.message);
                        this.isFlex = false;
                    }
                }, error => {console.log(error)}
            )

            this.previous();
        }
    }

    callProductsOfGroup(guidDoGrupo) {
        this.productsGroupService.getGroupsByGroup(guidDoGrupo, this.cedenteId).subscribe(response => {
            if (response.status === 1) {
                let assignorContractsId = [];
                this.productsByGroup = [];
                response.result.forEach(obj => {
                    if (obj.productCategory !== 2) {
                        this.productsByGroup.push(obj);
                        assignorContractsId.push(obj.assignorContractId);
                    } else {
                        this.productFlexGroup = obj;
                    }
                });
                this.cartaoService.getValidCardBatch(this.collaboratorId, this.currentUser.token.assignorGuid, assignorContractsId).subscribe(
                    responseB => {
                        if(response.status == ApiError.Sucesso){
                            //this.cards = responseB.result.sort((a, b) => a.productDescription.localeCompare(b.productDescription));
                            this.productsByGroup.forEach(element => {
                                element.expirated = responseB.result.find(x => x.productGuid == element.productGuid).expirated;
                            });
                        }
                    }
                );
            } else {
              this.alertService.error(response.message);
          }
        }, error => {
          this.alertService.error('Ocorreu um erro ao listar os produtos do grupo, tente novamente');
      });
    }

    tipobeneficio(v: number, toggle: boolean = false){
        this.cards = null;
        if(v == CategoriaProduto.Tradicional){
            this.tipoBeneficio = CategoriaProduto.Flex;
        }
        // if(v == CategoriaProduto.Tradicional && !toggle)
        //     this.tipoBeneficio = CategoriaProduto.Tradicional;
        // if(v == CategoriaProduto.Tradicional && toggle){
        //     if(this.grupoId > 0)
        //         this.tipoBeneficio = CategoriaProduto.Flex;
        //     else
        //         this.tipoBeneficio = CategoriaProduto.Tradicional;
        // }
        // if(v == CategoriaProduto.TradicionalPlus && !toggle)
        //     this.tipoBeneficio = CategoriaProduto.TradicionalPlus;
        // if(v == CategoriaProduto.TradicionalPlus && toggle){
        //     if(this.grupoId > 0)
        //         this.tipoBeneficio = CategoriaProduto.Flex;
        //     else
        //         this.tipoBeneficio = CategoriaProduto.TradicionalPlus;
        // }
        if(v == CategoriaProduto.Flex)
            this.tipoBeneficio = CategoriaProduto.Flex;
        if(v == CategoriaProduto.Incentivo)
            this.tipoBeneficio = CategoriaProduto.Incentivo;
        if(v == CategoriaProduto.IncentivoPlus)
            this.tipoBeneficio = CategoriaProduto.IncentivoPlus;
        if(v == CategoriaProduto.TradicionalPlus)
            this.tipoBeneficio = CategoriaProduto.TradicionalPlus;

        this.getContracts();

    }

    previous() {
        this.persistFilter = true;
        this.router.navigate(['list'], { relativeTo: this.route.parent });
    }

    selectBatch(item: Card, ativo: boolean) {
        if(!ativo && !this.cardsBatch.find(x => x.assignorContractId == item.assignorContractId)){
            this.cardsBatch.push(item)
        } else if(ativo) {
            this.cardsBatch = this.cardsBatch.filter(x => x.assignorContractId != item.assignorContractId)
        }
    }

}
